module.exports = __webpack_public_path__ + "img/public_resources_speed_white.2890bd44.svg";